// assets
import {
    IconMessageCircle,
    IconGraph,
    IconCalendar,
    IconSettings,
    IconClipboardData,
    IconBrandZoom,
    IconCoin,
    IconMessages,
    IconRobot,
    IconDashboard,
    IconBrandFramer,
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconLayoutGridAdd,
    IconUser,
    IconUsers,
    IconBuilding,
    IconEdit,
    IconUserSearch,
    IconUserPlus,
    IconTicket,
    IconArrowGuide,
    IconSpeakerphone,
    IconFilter,
    IconArrowsRightLeft,
    IconFileDots,
    IconBuildingStore,
    IconAddressBook,
    IconShoppingCart,
    IconTruckDelivery,
    IconBoxSeam,
    IconBellRinging,
    IconHome,
    IconBox,
    IconCategory,
    IconTag,
    IconBoxModel2,
    IconTools,
    IconBuildingWarehouse,
    IconMapPin,
    IconArrowsExchange,
    IconHistory,
    IconAdjustments,
    IconBarcode,
    IconListDetails,
    IconClipboardList,
    IconFileDescription,
    IconBuildingBank,
    IconUpload
} from '@tabler/icons';

import { IconSparkles } from '@tabler/icons-react';

// constant
const icons = {
    IconUserPlus: IconUserPlus,
    IconUserSearch: IconUserSearch,
    IconEdit: IconEdit,
    IconBuilding: IconBuilding,
    IconUser: IconUser,
    IconUsers: IconUsers,
    IconTicket: IconTicket,
    IconMessageCircle: IconMessageCircle,
    IconGraph: IconGraph,
    IconCalendar: IconCalendar,
    IconSettings: IconSettings,
    IconClipboardData: IconClipboardData,
    IconBrandZoom: IconBrandZoom,
    IconCoin: IconCoin,
    IconMessages: IconMessages,
    IconRobot: IconRobot,
    IconDashboard: IconDashboard,
    IconTypography: IconTypography,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconWindmill: IconWindmill,
    IconBrandFramer: IconBrandFramer,
    IconLayoutGridAdd: IconLayoutGridAdd,
    IconArrowGuide: IconArrowGuide,
    IconSpeakerphone: IconSpeakerphone,
    IconFilter: IconFilter,
    IconArrowsRightLeft: IconArrowsRightLeft,
    IconFileDots: IconFileDots,
    IconBuildingStore: IconBuildingStore,
    IconAddressBook: IconAddressBook,
    IconSparkles: IconSparkles,
    IconShoppingCart: IconShoppingCart,
    IconTruckDelivery: IconTruckDelivery,
    IconBoxSeam: IconBoxSeam,
    IconBellRinging: IconBellRinging,
    IconHome: IconHome,
    IconBox: IconBox,
    IconCategory: IconCategory,
    IconTag: IconTag,
    IconBoxModel2: IconBoxModel2,
    IconTools: IconTools,
    IconBuildingWarehouse: IconBuildingWarehouse,
    IconMapPin: IconMapPin,
    IconArrowsExchange: IconArrowsExchange,
    IconHistory: IconHistory,
    IconAdjustments: IconAdjustments,
    IconBarcode: IconBarcode,
    IconListDetails: IconListDetails,
    IconClipboardList: IconClipboardList,
    IconFileDescription: IconFileDescription,
    IconBuildingBank: IconBuildingBank,
    IconUpload: IconUpload
};

//-----------------------|| UTILITIES MENU ITEMS ||-----------------------//

export const utilities = {
    id: 'utilities',
    title: 'Painel',
    type: 'group',
    children: [
        {
            id: 'menu-home',
            title: 'Início',
            type: 'item',
            icon: icons['IconHome'],
            url: '/home',
            breadcrumbs: false
        },
        {
            id: 'menu-produtos',
            title: 'Produtos',
            type: 'collapse',
            icon: icons['IconBox'],
            children: [
                {
                    id: 'menu-produtos-catalogo',
                    title: 'Catálogo',
                    type: 'item',
                    icon: icons['IconBox'],
                    url: '/dashboard/config/products',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-produtos-categorias',
                    title: 'Categorias',
                    type: 'item',
                    icon: icons['IconCategory'],
                    url: '/dashboard/config/products/categories',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-produtos-marcas',
                    title: 'Marcas',
                    type: 'item',
                    icon: icons['IconTag'],
                    url: '/dashboard/config/products/brands',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-produtos-modelos',
                    title: 'Modelos',
                    type: 'item',
                    icon: icons['IconBoxModel2'],
                    url: '/dashboard/config/products/models',
                    breadcrumbs: false,
                    beta: false
                }
            ]
        },
        {
            id: 'menu-servicos',
            title: 'Serviços',
            type: 'collapse',
            icon: icons['IconTools'],
            children: [
                {
                    id: 'menu-servicos-catalogo',
                    title: 'Catálogo',
                    type: 'item',
                    icon: icons['IconTools'],
                    url: '/dashboard/config/services',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-servicos-categorias',
                    title: 'Categorias',
                    type: 'item',
                    icon: icons['IconCategory'],
                    url: '/dashboard/config/services/categories',
                    breadcrumbs: false,
                    beta: false
                }
            ]
        },
        {
            id: 'menu-sales',
            title: 'Vendas',
            type: 'collapse',
            icon: icons['IconShoppingCart'],
            children: [
                {
                    id: 'menu-sales-orders',
                    title: 'Pedidos de Venda',
                    type: 'item',
                    icon: icons['IconShoppingCart'],
                    url: '/dashboard/sales',
                    breadcrumbs: false
                },
                {
                    id: 'menu-sales-quotes',
                    title: 'Orçamentos',
                    type: 'item',
                    icon: icons['IconFileDescription'],
                    url: '/dashboard/sales/quotes',
                    breadcrumbs: false
                },
                {
                    id: 'menu-sales-price-tables',
                    title: 'Tabelas de Preços',
                    type: 'item',
                    icon: icons['IconTag'],
                    url: '/dashboard/sales/price-tables',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-purchasing',
            title: 'Compras',
            type: 'collapse',
            icon: icons['IconTruckDelivery'],
            children: [
                {
                    id: 'menu-purchasing-orders',
                    title: 'Pedidos de Compra',
                    type: 'item',
                    icon: icons['IconTruckDelivery'],
                    url: '/dashboard/purchasing',
                    breadcrumbs: false
                },
                {
                    id: 'menu-purchasing-requests',
                    title: 'Solicitações de Compra',
                    type: 'item',
                    icon: icons['IconClipboardList'],
                    url: '/dashboard/purchasing/requests',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-inventory',
            title: 'Estoque',
            type: 'collapse',
            icon: icons['IconBoxSeam'],
            children: [
                {
                    id: 'menu-inventory-posicao',
                    title: 'Posição de Estoque',
                    type: 'item',
                    icon: icons['IconBoxSeam'],
                    url: '/dashboard/inventory',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-movimentacoes',
                    title: 'Movimentações',
                    type: 'item',
                    icon: icons['IconHistory'],
                    url: '/dashboard/inventory/movements',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-novo-movimento',
                    title: 'Novo Movimento',
                    type: 'item',
                    icon: icons['IconAdjustments'],
                    url: '/dashboard/inventory/new',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-transferencias',
                    title: 'Transferências',
                    type: 'item',
                    icon: icons['IconArrowsExchange'],
                    url: '/dashboard/inventory/transfers',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-depositos',
                    title: 'Depósitos',
                    type: 'item',
                    icon: icons['IconBuildingWarehouse'],
                    url: '/dashboard/inventory/warehouses',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-localizacoes',
                    title: 'Localizações',
                    type: 'item',
                    icon: icons['IconMapPin'],
                    url: '/dashboard/inventory/warehouse-locations',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-lotes-series',
                    title: 'Lotes e Números de Série',
                    type: 'item',
                    icon: icons['IconBarcode'],
                    url: '/dashboard/inventory/lots-serials',
                    breadcrumbs: false
                },
                {
                    id: 'menu-inventory-kardex',
                    title: 'Kardex',
                    type: 'item',
                    icon: icons['IconListDetails'],
                    url: '/dashboard/inventory/kardex',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-reports',
            title: 'Relatórios',
            type: 'item',
            icon: icons['IconClipboardData'],
            url: '/dashboard/reports',
            breadcrumbs: false
        },
        {
            id: 'menu-financeiro',
            title: 'Financeiro',
            type: 'collapse',
            icon: icons['IconUsers'],
            children: [
                {
                    id: 'menu-financeiro-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    icon: icons['IconCoin'],
                    url: '/dashboard/financial',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-financeiro-contas-pagar',
                    title: 'Contas a pagar',
                    type: 'item',
                    icon: icons['IconUserSearch'],
                    url: '/dashboard/financial/payable',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-financeiro-contas-receber',
                    title: 'Contas a receber',
                    type: 'item',
                    icon: icons['IconUserPlus'],
                    url: '/dashboard/financial/receivable',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-financeiro-caixa',
                    title: 'Caixa',
                    type: 'item',
                    icon: icons['IconArrowsRightLeft'],
                    url: '/dashboard/financial/cashflow',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-financeiro-contas-bancarias',
                    title: 'Contas Bancárias',
                    type: 'item',
                    icon: icons['IconBuildingBank'],
                    url: '/dashboard/financial/bank-accounts',
                    breadcrumbs: false
                },
                {
                    id: 'menu-financeiro-conciliacao',
                    title: 'Conciliação Bancária',
                    type: 'item',
                    icon: icons['IconUpload'],
                    url: '/dashboard/financial/reconciliation',
                    breadcrumbs: false
                },
                {
                    id: 'menu-financeiro-cobranca',
                    title: 'Régua de Cobrança',
                    type: 'item',
                    icon: icons['IconBellRinging'],
                    url: '/dashboard/financial/collection-rules',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-rh',
            title: 'RH',
            type: 'collapse',
            icon: icons['IconUsers'],
            children: [
                {
                    id: 'menu-rh-colaboradores',
                    title: 'Colaboradores',
                    type: 'item',
                    icon: icons['IconUserPlus'],
                    url: '/dashboard/hr/colaboradores',
                    breadcrumbs: false
                },
                {
                    id: 'menu-rh-departamentos',
                    title: 'Departamentos',
                    type: 'item',
                    icon: icons['IconBuilding'],
                    url: '/dashboard/hr/departments',
                    breadcrumbs: false
                },
                {
                    id: 'menu-rh-cargos',
                    title: 'Cargos',
                    type: 'item',
                    icon: icons['IconUserSearch'],
                    url: '/dashboard/hr/roles',
                    breadcrumbs: false
                },
                {
                    id: 'menu-rh-ferias',
                    title: 'Férias e Afastamentos',
                    type: 'item',
                    icon: icons['IconCalendar'],
                    url: '/dashboard/hr/leave-requests',
                    breadcrumbs: false
                },
                {
                    id: 'menu-rh-folha',
                    title: 'Folha de Pagamento',
                    type: 'item',
                    icon: icons['IconCoin'],
                    url: '/dashboard/hr/payroll',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-production',
            title: 'Linha de Produção',
            type: 'collapse',
            icon: icons['IconTools'],
            requiresAccountType: ['industria'],
            children: [
                {
                    id: 'menu-production-bom',
                    title: 'Fichas Técnicas',
                    type: 'item',
                    icon: icons['IconClipboardList'],
                    url: '/dashboard/production/bom',
                    breadcrumbs: false
                },
                {
                    id: 'menu-production-orders',
                    title: 'Ordens de Produção',
                    type: 'item',
                    icon: icons['IconListDetails'],
                    url: '/dashboard/production/orders',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'menu-organizations',
            title: 'Empresas',
            type: 'item',
            icon: icons['IconBuilding'],
            url: '/dashboard/config/organizations/view',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'menu-suppliers',
            title: 'Fornecedores',
            type: 'item',
            icon: icons['IconBuildingWarehouse'],
            url: '/dashboard/config/suppliers',
            breadcrumbs: false,
            beta: false
        },
        {
            id: 'menu-users',
            title: 'Clientes',
            type: 'collapse',
            icon: icons['IconUsers'],
            children: [
                {
                    id: 'menu-users-view',
                    title: 'Ver Clientes',
                    type: 'item',
                    icon: icons['IconUserSearch'],
                    url: '/dashboard/config/users/view',
                    breadcrumbs: false,
                    beta: false
                },
                {
                    id: 'menu-users-add',
                    title: 'Criar Cliente',
                    type: 'item',
                    icon: icons['IconUserPlus'],
                    url: '/dashboard/config/users/create',
                    breadcrumbs: false,
                    beta: false
                }
            ]
        },
        {
            id: 'menu-notifications',
            title: 'Notificações',
            type: 'item',
            icon: icons['IconBellRinging'],
            url: '/dashboard/admin/notifications',
            breadcrumbs: false
        }
    ]
};
